import { render } from "./view_lab_results.vue?vue&type=template&id=594f40e1&scoped=true"
import script from "./view_lab_results.vue?vue&type=script&lang=js"
export * from "./view_lab_results.vue?vue&type=script&lang=js"

import "./view_lab_results.vue?vue&type=style&index=0&id=594f40e1&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594f40e1"]])

export default __exports__